<template>
  <!-- 人员准入 -->
  <!-- pc端 -->
  <div v-if="isPCFlag" class="solutionSafety">
    <!-- 第一部分顶部大图导航 -->
    <topBigPic :topBgImg="topBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></topBigPic>

    <!-- 第二部分 -->
    <div class="containers">
      <div class="honor_header ">
        <h1 ref="HeaderTitle">产品简介</h1>
        <div class="mian_Info" ref="honorMain">
          <p>人员准入系统基于识别设备、抓拍机、UWB定位等设备的技术支撑，实现了身份识别、测温、人脸、健康码、轨迹、
            核酸报告、资信库等，<br />七位一体的特色准入模式，应用范围覆盖办公场所、生产场所，能够应对多种业务场景下的人员到访、准入及定位，实现全方位准入管控新模式。</p>
        </div>
        <div class="honorImg" ref="honorImg">
          <div class="shade" ref="shadeHonorImg"></div>
          <img src="../../assets/imgs/solution/synopsis_renyuan.jpg" ref="imgHonorImg">
        </div>
      </div>
    </div>

    <!-- 第三部分 目标用户-->
    <keyfeature :keyFeature="keyFeature"></keyfeature>

    <!-- 第四部分 -->
    <systemfeatures :systemFeatures="systemFeatures"></systemfeatures>

    <!-- 第五部分 -->
    <applicationresults :applicationResults="applicationResults"></applicationresults>

    <!-- 尾部公用组件 -->
    <bottomFooter></bottomFooter>
  </div>
  <!-- 移动端 -->
  <div v-else class="mobileSolutionSafety">
    <!-- 第一部分顶部大图导航 -->
    <mobileTopBigPic :topBgImg="mobileTopBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></mobileTopBigPic>

    <!-- 第二部分 -->
    <div class="mobile-about-part2">
      <div class="title ml71">
        产品简介
      </div>
      <div class="info mobile-container padding-bottom-213">
        人员准入系统基于识别设备、抓拍机、UWB定位等设备的技术支撑，实现了身份识别、测温、人脸、健康码、轨迹、核酸报告、资信库等，七位一体的特色准入模式，应用范围覆盖办公场所、生产场所，能够应对多种业务场景下的人员到访、准入及定位，实现全方位准入管控新模式。
      </div>
      <div class="bg"></div>
    </div>

    <!-- 第三部分 目标用户-->
    <mbKeyfeature :keyFeature="mbKeyFeature"></mbKeyfeature>

    <!-- 第四部分 -->
    <mbSystemfeatures :systemFeatures="mbSystemFeatures"></mbSystemfeatures>

    <!-- 第五部分 -->
    <mbApplicationresults :applicationResults="mbApplicationResults"></mbApplicationresults>

    <!-- 尾部公用组件 -->
    <mobileBottomFooter></mobileBottomFooter>
  </div>
</template>

<script>
import topBigPic from "@/components/global/topBigPic.vue";
import bottomFooter from "@/components/global/bottomFooter.vue";
import keyfeature from "@/components/solution/keyfeature.vue";
import systemfeatures from "@/components/solution/systemfeatures.vue";
import applicationresults from "@/components/solution/applicationresults.vue";
import mobileTopBigPic from "@/components/global/mobileTopBigPic";
import mobileBottomFooter from "@/components/global/mobileBottomFooter.vue";
import mbKeyfeature from "@/components/solution/mbKeyfeature.vue";
import mbSystemfeatures from "@/components/solution/mbSystemfeatures.vue";
import mbApplicationresults from "@/components/solution/mbApplicationresults.vue";

import animationUtils from "@/utils/animationUtils.js";
import { isPC } from "@/utils/tools.js";

export default {
  name: "solutionadmi",
  data() {
    return {
      isPCFlag: true,
      //顶部导航数据
      topBgImg: require("../../assets/imgs/solution/topbgrenyuan.jpg"),
      mobileTopBgImg: require("../../assets/imgs/mobileSolution/topbgrenyuan.jpg"),
      bigTitle: {
        znTitle: "人员准入",
        enTitle: "PERSONNEL ACCESS MANAGEMENT",
      },
      menuLi: {
        sortOne: {
          title: "解决方案",
          children: [
            {
              name: "产品中心",
              active: false,
              url: "/comdedeauto",
            },
            {
              name: "解决方案",
              active: true,
              url: "/solutionadmi",
            },
            {
              name: "新闻动态",
              active: false,
              url: "/companyNews",
            },
            {
              name: "关于我们",
              active: false,
              url: "/companyprofile",
            },
            {
              name: "职等你来",
              active: false,
              url: "/jobmarket",
            },
          ],
        },

        sortTwo: {
          title: "人员准入",
          children: [
            {
              name: "人员准入",
              active: true,
              url: "/solutionadmi",
            },
            {
              name: "安全工器具",
              active: false,
              url: "/solutionSafety",
            },
            {
              name: `“项目+资产”移动作业系统`,
              active: false,
              url: "/projectassets",
            },
          ],
        },
      },
      //主要功能
      keyFeature: {
        part1: [
          {
            bg: require("../../assets/imgs/solution/credit_construction.png"),
            title: "资信建设",
            info: "标准资信库包括人员资信库和企业资信库。",
          },
          {
            bg: require("../../assets/imgs/solution/electronic_certificate.png"),
            title: "电子证件",
            info: "支持多种证件，不同工作证具备不同区域的进入权限，满足各类人员的准入需求。",
          },
          {
            bg: require("../../assets/imgs/solution/access_controls.png"),
            title: "准入管控",
            info: "通过移动端快速提交准入申请，并基于人脸、车牌等识别设备，自动匹配人员权限并控制入场闸机放行。",
          },
          {
            bg: require("../../assets/imgs/solution/precise_localization.png"),
            title: "精准定位",
            info: "进入定位区域以后，其位置信息实时获取，并显示到指挥中心的大屏幕。",
          },
          {
            bg: require("../../assets/imgs/solution/electronic_fence.png"),
            title: "电子围栏",
            info: "通过在地图上划定电子围栏，当人员进入非授权区域时，将及时做出预警。",
          },
        ],
        part2: [
          {
            bg: require("../../assets/imgs/solution/historical_route.png"),
            title: "历史轨迹",
            info: "支持10万级定位目标轨迹，长达一年精准定位数据循环保存，支持回放。",
          },
          {
            bg: require("../../assets/imgs/solution/safety_supervision.png"),
            title: "安全督查",
            info: "巡查人员在作业现场对可疑人员拍照，系统根据人脸信息自动获取人员基础数据和电子工作证。",
          },
          {
            bg: require("../../assets/imgs/solution/access_analysis.png"),
            title: "准入分析",
            info: "统计分析数据以可视化方式对变电站人员准入情况直观展示，提升变电站人员管理水平。",
          },
          {
            bg: require("../../assets/imgs/solution/agent_machine.png"),
            title: "智能准入一体机",
            info: "将红外测温、人脸识别、身份证识别、健康码识别、状态指示进行一体化集成，实现自动化数据采集与传输，智能判断是否准入。",
          },
          {
            bg: require("../../assets/imgs/solution/UWBprecise_localization.png"),
            title: "UWB精准定位",
            info: "实现场所内对人员及车辆进行精准定位，具有定位精度高（最高精度达到10CM）、承载容量无限制、抗干扰能力强、节能等技术特点。",
          },
        ],
      },
      mbKeyFeature: {
        part1: [
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/credit_construction.png"),
            title: "资信建设",
            info: "标准资信库包括人员资信库和企业资信库。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/electronic_certificate.png"),
            title: "电子证件",
            info: "支持多种证件，不同工作证具备不同区域的进入权限，满足各类人员的准入需求。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/access_controls.png"),
            title: "准入管控",
            info: "通过移动端快速提交准入申请，并基于人脸、车牌等识别设备，自动匹配人员权限并控制入场闸机放行。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/precise_localization.png"),
            title: "精准定位",
            info: "进入定位区域以后，其位置信息实时获取，并显示到指挥中心的大屏幕。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/electronic_fence.png"),
            title: "电子围栏",
            info: "通过在地图上划定电子围栏，当人员进入非授权区域时，将及时做出预警。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/historical_route.png"),
            title: "历史轨迹",
            info: "支持10万级定位目标轨迹，长达一年精准定位数据循环保存，支持回放。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/safety_supervision.png"),
            title: "安全督查",
            info: "巡查人员在作业现场对可疑人员拍照，系统根据人脸信息自动获取人员基础数据和电子工作证。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/access_analysis.png"),
            title: "准入分析",
            info: "统计分析数据以可视化方式对变电站人员准入情况直观展示，提升变电站人员管理水平。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/agent_machine.png"),
            title: "智能准入一体机",
            info: "将红外测温、人脸识别、身份证识别、健康码识别、状态指示进行一体化集成，实现自动化数据采集与传输，智能判断是否准入。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionadmi/UWBprecise_localization.png"),
            title: "UWB精准定位",
            info: "实现场所内对人员及车辆进行精准定位，具有定位精度高（最高精度达到10CM）、承载容量无限制、抗干扰能力强、节能等技术特点。",
          },
        ],
      },
      //系统特色
      systemFeatures: {
        part1: [
          {
            img: require("../../assets/imgs/solution/personnel_access_feature_01.jpg"),
            index: "01",
            info: "人员准入流程闭环，提升安全水平",
          },
          {
            img: require("../../assets/imgs/solution/personnel_access_feature_02.jpg"),
            index: "02",
            info: "移动终端申请审核，确保便捷高效",
          },
          {
            img: require("../../assets/imgs/solution/personnel_access_feature_03.jpg"),
            index: "03",
            info: "人脸识别无感准入，智能身份核验",
          },
        ],
        part2: [
          {
            img: require("../../assets/imgs/solution/personnel_access_feature_04.jpg"),
            index: "04",
            info: "精准人员车辆定位，规范作业范围",
          },
          {
            img: require("../../assets/imgs/solution/personnel_access_feature_05.jpg"),
            index: "05",
            info: "电子围栏自由划定，支持越界报警",
          },
          {
            img: require("../../assets/imgs/solution/personnel_access_feature_06.jpg"),
            index: "06",
            info: "电子证件随时核验，高效安全追责",
          },
        ],
      },
      mbSystemFeatures: {
        part1: [
          {
            img: require("../../assets/imgs/mobileSolution/solutionadmi/personnel_access_feature_01.jpg"),
            index: "01",
            info: "人员准入流程闭环，提升安全水平",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionadmi/personnel_access_feature_02.jpg"),
            index: "02",
            info: "移动终端申请审核，确保便捷高效",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionadmi/personnel_access_feature_03.jpg"),
            index: "03",
            info: "人脸识别无感准入，智能身份核验",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionadmi/personnel_access_feature_04.jpg"),
            index: "04",
            info: "精准人员车辆定位，规范作业范围",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionadmi/personnel_access_feature_05.jpg"),
            index: "05",
            info: "电子围栏自由划定，支持越界报警",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionadmi/personnel_access_feature_06.jpg"),
            index: "06",
            info: "电子证件随时核验，高效安全追责",
          },
        ],
      },
      applicationResults: {
        bg: require("../../assets/imgs/solution/applicationresults_ry.jpg"),
        dataLi: {
          part1: [
            {
              img: require("../../assets/imgs/solution/applicationresults_ry01.png"),
              title: "准入资信，协同共享",
            },
            {
              img: require("../../assets/imgs/solution/applicationresults_ry02.png"),
              title: "移动操作，便捷高效",
            },
            {
              img: require("../../assets/imgs/solution/applicationresults_ry03.png"),
              title: "人员准入，高效管控",
            },
            {
              img: require("../../assets/imgs/solution/applicationresults_ry04.png"),
              title: "移动轨迹，实时追溯",
            },
          ],
          part2: [
            {
              img: require("../../assets/imgs/solution/applicationresults_ry05.png"),
              title: "视频联动，全景监控",
            },
            {
              img: require("../../assets/imgs/solution/applicationresults_ry06.png"),
              title: "数据协同，精准可靠",
            },
            {
              img: require("../../assets/imgs/solution/applicationresults_ry07.png"),
              title: "严格把控，数据入库",
            },
            {
              img: require("../../assets/imgs/solution/applicationresults_ry08.png"),
              title: "数据展示，实时直观",
            },
          ],
        },
      },
      mbApplicationResults: {
        bg: require("../../assets/imgs/mobileSolution/solutionadmi/applicationresults_ry.jpg"),
        dataLi: {
          part1: [
            {
              img: require("../../assets/imgs/mobileSolution/solutionadmi/applicationresults_ry01.png"),
              title: "准入资信，协同共享",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionadmi/applicationresults_ry02.png"),
              title: "移动操作，便捷高效",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionadmi/applicationresults_ry03.png"),
              title: "人员准入，高效管控",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionadmi/applicationresults_ry04.png"),
              title: "移动轨迹，实时追溯",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionadmi/applicationresults_ry05.png"),
              title: "视频联动，全景监控",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionadmi/applicationresults_ry06.png"),
              title: "数据协同，精准可靠",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionadmi/applicationresults_ry07.png"),
              title: "严格把控，数据入库",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionadmi/applicationresults_ry08.png"),
              title: "数据展示，实时直观",
            },
          ],
        },
      },
    };
  },
  created() {
    this.isPCFlag = isPC();
  },
  mounted() {
    this.isPCFlag ? window.addEventListener("scroll", this.menu) : "";
  },
  beforeDestroy() {
    //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
    this.isPCFlag ? window.removeEventListener("scroll", this.menu) : "";
  },
  methods: {
    //滚动条监听
    menu() {
      /**
       * animations方法的第一个参数是需要动画的dom元素的高度，
       * 第二个参数是需要加动画的dom元素的样式列表数组，
       * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
       */
      //第二部分标题动画
      let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
      let HeaderTitle = this.$refs.HeaderTitle.classList;
      //
      animationUtils.animations(
        HeaderTitleOffsetTop,
        HeaderTitle,
        "activeTitle"
      );

      //第二部分图的动画
      let honorImgOffsetTop = this.$refs.honorImg.offsetTop; //获取当前元素距离文档顶部的高度
      let shadeHonorImg = this.$refs.shadeHonorImg.classList; //遮罩样式数组
      let imgHonorImg = this.$refs.imgHonorImg.classList; //图片样式数组
      animationUtils.animations(
        honorImgOffsetTop,
        shadeHonorImg,
        "activeShade"
      );
      animationUtils.animations(honorImgOffsetTop, imgHonorImg, "activeImg");

      //第二部分文字描述动画
      let honorMainOffsetTop = this.$refs.honorMain.offsetTop;
      let honorMainClassList = this.$refs.honorMain.classList;
      animationUtils.animations(
        honorMainOffsetTop,
        honorMainClassList,
        "activeTitle"
      );
    },
  },
  components: {
    topBigPic,
    bottomFooter,
    keyfeature,
    systemfeatures,
    applicationresults,
    mobileTopBigPic,
    mobileBottomFooter,
    mbKeyfeature,
    mbSystemfeatures,
    mbApplicationresults,
  },
};
</script>

<style lang="scss" scoped>
.mobileSolutionSafety {
  .padding-bottom-213 {
    padding-bottom: 213px;
  }

  .mobile-about-part2 {
    .title {
      width: 1720px;
      height: 180px;
      line-height: 180px;
      font-size: 156px;
      font-weight: 600;
      padding: 284px 0 174px;
      box-sizing: content-box;
      color: #000000;
    }
    .bg {
      height: 1152px;
      background: url(../../assets/imgs/mobileSolution/synopsis_renyuan.jpg)
        no-repeat;
      background-size: cover;
    }
    .info {
      font-size: 71px;
      font-weight: 400;
      color: #323333;
      line-height: 128px;
      text-align: justify;
    }
  }
}
</style>